export const getSubUrl = (url) => {
  const subUrl = url.split('/')[2];
  return subUrl;
};
